const HAS_TIMEZONE = /(Z|[+-]\d{2}:\d{2})$/;

// The backend sends naive timestamps that are UTC; mark them so `new Date`
// doesn't read them as local time.
export const normalizeTimestamp = timestamp => {
	if (!timestamp) return null;
	if (timestamp instanceof Date) return timestamp.toISOString();
	if (typeof timestamp === 'number') return new Date(timestamp).toISOString();
	if (typeof timestamp === 'string' && !HAS_TIMEZONE.test(timestamp)) {
		return `${timestamp}Z`;
	}
	return timestamp;
};
